<template>
  <div>


    <b-card-code>
      <b-row>
        <b-col cols="6" xl="6">
          <table class="table table-bordered table-sm table-striped">
            <tbody>
              <tr>
                <th><span class="font-weight-bold">Nama Shift</span></th>
                <td>{{ detail.name }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Kode Shift</span></th>
                <td>{{ detail.shiftCode }}</td>
              </tr>
              <tr>
                <th>
                  <span class="font-weight-bold">Jam Kerja (perbulan)</span>
                </th>
                <td>{{ detail.averageHour }}</td>
              </tr>
              <tr>
                <th><span class="font-weight-bold">Jam Awal Lembur</span></th>
                <td>{{ detail.startOvertime }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-card-code>

    <b-card-code>

      <b-row>
      <b-col md="4" class="mb-1">
        <b-form-input placeholder="Cari" v-model="filter.name" />
      </b-col>
      <b-col class="mb-1 text-right">
        <FormShiftDetail
          :is-loading="isLoading"
          :edit-id="editId"
          :create-item="createItem"
          :update-item="updateItem"
          :clean-up-form="cleanUpForm"
          :form-payload="formPayload"
          @payloadShiftDetail="getPayload($event)"
        />
      </b-col>
    </b-row>

      <ListShiftDetail
        :result="result"
        :is-loading="isLoading"
        :edit-item="editItem"
        :detail-item="detailItem"
        :delete-item="deleteItem"
      />

    </b-card-code>



  </div>
</template>

<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BButton,
  BSpinner,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
  BImg,
  BRow,
  BCol,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";

import ListShiftDetail from "@/components/ShiftDetail/ListShiftDetail.vue";
import FormShiftDetail from "@/components/ShiftDetail/FormShiftDetail.vue";

export default {
  components: {
    BButton,
    BSpinner,
    BFormInput,
    BFormCheckbox,
    BFormFile,
    BFormSelect,
    BImg,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    required,
    BRow,
    BCol,
    BCardCode,
    ListShiftDetail,
    FormShiftDetail,
  },
  directives: {
    Ripple,
  },
  props: {
    // result: {
    //   type: "",
    // },
  },
  watch: {
    filter: {
      handler: _.debounce(function (value) {
        this.getData();
      }, 300),
      deep: true,
    },
  },
  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      isLoading: false,
      id: this.$route.params.id,
      result: {},
      detail: {},
      editId: null,
      formPayload: Object,
      employeeData: Object,
      filter: {
        name: "",
      },
    };
  },
  created() {
    this.getDetail()
    this.getData()
  },
  methods: {
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    cleanUpForm() {
      this.editId = null;
      this.formPayload = {
        day: "",
        endShift: "",
        name: "",
        shiftId: this.id,
        startShift: ""
      };
    },
    detailItem(item) {
      this.detail = item;
      this.$bvModal.show('detail-shift-detail-modal')
    },
    createItem() {
      this.getPayload()
      const form = this.formPayload
      this.isLoading = true

      this.$http
        .post("/mastering/shiftDetail", form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            this.$bvModal.hide("form-shift-detail-modal");
            this.getData();
            successNotification(this, "Success", "Detail shift berhasil di buat");
            this.cleanUpForm();
          }
          
          this.isLoading = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);
          this.isLoading = false;
        });
    },
    updateItem() {
      const form = this.formPayload
      this.isLoading = true;

      this.$http
        .put(`/mastering/shiftDetail/${this.editId}`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code !== '00' ) {
            errorNotification(this, "Oops!", response.data.message);
          } else {
            this.$bvModal.hide("form-shift-detail-modal");
            this.getData();
            successNotification(this, "Success", "Detail shift berhasil di ubah!");
            this.cleanUpForm();
          }
          
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('error')
          console.log(error)
          this.isLoading = false;
        });
    },
    editItem(item) {
      this.cleanUpForm();
      this.editId = item.id;
      console.log(item)
      this.formPayload = {
        day: item.day,
        endShift: item.endShift,
        name: item.name,
        shiftId: item.shift ? item.shift.shiftId : item.shift,
        startShift: item.startShift,
      };
      this.$bvModal.show("form-shift-detail-modal");
    },
    deleteItem(id) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/mastering/shiftDetail/${id}`)
            .then((response) => {
              this.getData(this.currentPage);
              this.$swal({
                icon: "success",
                title: "Berhasil!",
                text: "Detail shift berhasil di hapus",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            });
        }
      });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      queryParams.shiftId = this.id;

      this.$http
        .get("/mastering/shiftDetail/findAll", {
          params: queryParams,
        })
        .then((response) => {
          this.result = response.data.data;
          this.isLoading = false;
        });
    },
    getDetail() {
      this.isLoading = true;
      this.$http.get("/mastering/shift/" + this.id, {}).then((response) => {
        this.detail = response.data.data;
        this.isLoading = false;
      });
    },
  },
};
</script>
